import { AllInfluencers } from '@anytag/shared-organisms';
import { useAllInfluencersSelectForPackage } from './hooks';

export const AllInfluencersSearch = () => {
  const { getSortSelectButtonProps, getListSelectButtonProps } = useAllInfluencersSelectForPackage();

  return (
    <AllInfluencers
      getSortSelectButtonProps={getSortSelectButtonProps}
      getListSelectButtonProps={getListSelectButtonProps}
    />
  );
};
